export function getView(ortho_coverage) {
  return ortho_coverage ? 'RemoveAction' : 'AddAction'
}
